import { Component, OnInit, Input, Pipe, PipeTransform, ViewChild, QueryList, ViewChildren } from '@angular/core';
import { MachineService } from '../machine/machineService';
import { Machine } from '../machine/machine';
import { StatusService } from '../status/statusService';
import { Status } from '../status/status';
import { Ticket, TicketCreate } from '../ticket/ticket';
import { Client } from '../client/client';
import { UserProfileComponent } from '../user-profile/user-profile.component';
import { UserService } from '../_services';
import { User } from '../user/user';
import { ClientService } from '../client/clientservice';
import { TicketService } from '../ticket/ticketService';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { headersToString } from 'selenium-webdriver/http';

import { DatePipe } from '@angular/common';
import { time } from 'console';
import { ML } from '../comment/ML';
import { Sendgridservice } from '../_services/sendgridService';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-ticket-create',
  templateUrl: './ticket-create.component.html',
  styleUrls: ['./ticket-create.component.less', '../app.component.less'],
  providers: [DatePipe]
})
export class TicketCreateComponent implements OnInit {
  @Input() selectedMachine: Machine;
  _machines: Machine[];
  _selectedmachineid: number = 1;
  _statuses: Status[];
  _selectedstatusid: number = 1;
  _newticket: TicketCreate;
  _client: Client;
  _currentUser: User;
  _title: string;
  _details: string;
  _newstatus: Status;
  redirecturl: string;
  _errorcode: string;
  _current_counter: number;
  
  ml: ML;

  public Editor = ClassicEditor;
  ticketdetails = "";
  constructor(private machineservice: MachineService,
    private statusservice: StatusService,
    private userservice: UserService,
    private clientservice: ClientService,
    private ticketservice: TicketService,
    private router: Router,
    private activateroute: ActivatedRoute,
    private datePipe: DatePipe,
    private sendgridservice: Sendgridservice,) { }


  ngOnInit() {

    // Getting the current user if user is logged in. 
    //Redirects to login page if false
    try {
      this._selectedmachineid = 0;
      this.statusservice.getStatuses().subscribe(statuses => this._statuses = statuses);
      this.userservice.getCurrentUser().subscribe(response => {
        this._currentUser = response;
        if (this._currentUser.client.id == 3)// If  user is part of CS TEAM => get all Machines
        {
          this.machineservice.getMachines().subscribe(machines => this._machines = machines);
        }
        else // If user is client => Get Client Machines only
        {
          this.clientservice.getClientById(this._currentUser.client.id).subscribe(response => {
            this._client = response;
            this.machineservice.getClientMachines(response.id).subscribe(resp => { this._machines = resp; });
          });
        }
      });
    }
    catch {
      window.alert("Please login to post a new ticket");
      window.location.href = environment.ticketingURL;
    }

    // Geting the URL parameter if present id > 0 
    const id = +this.activateroute.snapshot.paramMap.get('id');

    if (id > 0) // If machine id parameter is passed in url
    {
      this._selectedmachineid = id
      this.machineservice.getMachine(id).subscribe(response => this.selectedMachine = response);
    }

  }

  getSelectedId() {
    console.log(this._selectedstatusid);
    console.log(this._selectedmachineid);
  }

  createTicket() {
    console.log("the seleceted machine is");

    this.machineservice.getMachine(this._selectedmachineid).subscribe(response => {
      this.selectedMachine = response;
      this._newstatus = new Status;
      this._newstatus.id = this._selectedstatusid;
      this._newticket = new TicketCreate;
      this._newticket.title = this._title;
      this._newticket.details = this.ticketdetails
      this._newticket.status = this._newstatus.id;
      this._newticket.machines = this._selectedmachineid;
      this._newticket.user = this._currentUser.id;
      this._newticket.client = this.selectedMachine.client.id;
      this._newticket.errorcode = this._errorcode;
      this._newticket.current_counter = this._current_counter;
      var timestamp = new Date();
      this.datePipe.transform(timestamp, "yyy-MM-dd");
      this._newticket.dateofticket = timestamp;
      this._newticket.dateresolved = timestamp;
      this._newticket.resolution = "";
      


      this.ticketservice.createTicket(this._newticket).subscribe(response => {

        this.machineservice.updateMachineCounter(this._selectedmachineid, this._current_counter).subscribe(resp => { }
        );
        this._newticket.id = response.id;
        this.redirecturl = "/ticketviews/" + this._newticket.id;
        this.router.navigateByUrl(this.redirecturl);
      });
      this.ml = new ML();
      this.ml.content = this._newticket.details.replace(/<[^>]+>/g, '');
      this.ml.subject = this._newticket.title;
      this.ml.sender = this._currentUser.firstname + " " + this._currentUser.lastname;
      this.ml.senton = timestamp;
      this.ml.senderemail = this._currentUser.email;
      this.ml.receipientemail = "issam.khatib@k2ss.fr"
      this.sendgridservice.sendMail(this.ml).subscribe(any => { });
    });
  }
}
